import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { Card } from 'primereact/card';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import SidebarMenu from "../components/SidebarMenu";

const ProfilePage = () => {
  const [user, setUser] = useState(null);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: '',
    newPassword: '',
  });
  const [updatingPassword, setUpdatingPassword] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await api.get("/users/me");
        setUser(response.data);
      } catch (error) {
        console.error("Profil verisi alınamadı:", error);
      }
    };
    fetchProfile();
  }, []);

  const handlePasswordFieldChange = (field, value) => {
    setPasswordForm((prev) => ({ ...prev, [field]: value }));
  };

  const handlePasswordSubmit = async (event) => {
    event.preventDefault();

    if (!passwordForm.currentPassword || !passwordForm.newPassword) {
      toast.error('Lütfen mevcut ve yeni şifre alanlarını doldurun.');
      return;
    }

    if (passwordForm.newPassword.length < 6) {
      toast.error('Yeni şifre en az 6 karakter olmalıdır.');
      return;
    }

    try {
      setUpdatingPassword(true);
      await api.post('/auth/change-password', {
        current_password: passwordForm.currentPassword,
        new_password: passwordForm.newPassword,
      });
      toast.success('Şifreniz başarıyla güncellendi.');
      setPasswordForm({ currentPassword: '', newPassword: '' });
    } catch (error) {
      console.error('Şifre güncellenemedi:', error);
    } finally {
      setUpdatingPassword(false);
    }
  };

  const formatDate = (value) => {
    if (!value) return 'Belirtilmemiş';
    try {
      return new Date(value).toLocaleDateString('tr-TR');
    } catch (error) {
      return value;
    }
  };

  const formatEndDate = (value) => {
    if (!value) return 'Halen';
    return formatDate(value);
  };

  if (!user) return <div>Yükleniyor...</div>;

  return (
    <div className="layout">
      <SidebarMenu />
      <main className="content">
        <div className="grid">
          <div className="col-6">
            <Card className="w-[400px] shadow-md">
              <h2 className="text-lg font-semibold mb-2">Profil Bilgileri</h2>
              <p><strong>Ad Soyad:</strong> {user.first_name} {user.last_name}</p>
              <p><strong>Email:</strong> {user.email}</p>
              <p><strong>Telefon:</strong> {user.phone_number}</p>
              <p><strong>Doğum Tarihi:</strong> {user.birth_date}</p>
              <p><strong>Başlangıç Tarihi:</strong> {user.start_date}</p>
            </Card>
          </div>

          <div className="col-6">
            <Card className="w-[400px] shadow-md">
              <h2 className="text-lg font-semibold mb-2">Departman & Pozisyonlar</h2>
              <ul className="space-y-1 text-sm">
                {user.departments_with_positions.map((dp) => (
                  <li key={`${dp.department_id}-${dp.position_id}`}>
                    <div className="flex flex-column">
                      <span>{dp.department_name} - {dp.position_name}</span>
                      <span className="text-xs opacity-70">Başlangıç Tarihi: {formatDate(dp.start_date)}</span>
                      <span className="text-xs opacity-70">Bitiş Tarihi: {formatEndDate(dp.end_date)}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </Card>
          </div>

          <div className="col-6">
            <Card className="w-[400px] shadow-md">
              <h2 className="text-lg font-semibold mb-2">Onay Hiyerarşileri</h2>
              <div className="space-y-1 text-sm">
                <p><strong>İzin Onayı:</strong> {user.approval_hierarchy?.name}</p>
                <p><strong>Harcama Onayı:</strong> {user.expense_approval_hierarchy?.name}</p>
              </div>
            </Card>
          </div>

          <div className="col-6">
{/* YENİ EKLENEN KART: Skill & Level listesi */}
            <Card className="w-[400px] shadow-md">
              <h2 className="text-lg font-semibold mb-2">Yetenekler (Yetenek & Seviye)</h2>
              {user.skills && user.skills.length > 0 ? (
                <ul className="space-y-1 text-sm">
                  {user.skills.map((s) => (
                    <li key={s.skill_id} className="flex justify-between">
                      <span>
                        {s.skill?.hierarchy?.name ? (
                          <span className="opacity-70"> {s.skill.hierarchy.name}  </span>
                        ) : null}
                        <strong> {" "+s.skill?.name+"" ?? 'Bilinmeyen Skill'} - </strong>
                      </span>
                      <span>  {" Level: "+s.level}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm opacity-70">Henüz skill eklenmemiş.</p>
              )}
            </Card>
          </div>

          <div className="col-6">
            <Card className="w-[400px] shadow-md">
              <h2 className="text-lg font-semibold mb-2">Şifreni Güncelle</h2>
              <form className="flex flex-column gap-3" onSubmit={handlePasswordSubmit}>
                <div className="flex flex-column gap-1">
                  <label className="text-sm font-medium" htmlFor="current-password">Mevcut Şifre</label>
                  <Password
                    id="current-password"
                    value={passwordForm.currentPassword}
                    onChange={(e) => handlePasswordFieldChange('currentPassword', e.target.value)}
                    toggleMask
                    feedback={false}
                    inputClassName="w-full"
                    className="w-full"
                    disabled={updatingPassword}
                  />
                </div>
                <div className="flex flex-column gap-1">
                  <label className="text-sm font-medium" htmlFor="new-password">Yeni Şifre</label>
                  <Password
                    id="new-password"
                    value={passwordForm.newPassword}
                    onChange={(e) => handlePasswordFieldChange('newPassword', e.target.value)}
                    toggleMask
                    feedback={false}
                    inputClassName="w-full"
                    className="w-full"
                    disabled={updatingPassword}
                  />
                </div>
                <Button type="submit" label="Şifremi Güncelle" icon="pi pi-lock" loading={updatingPassword} />
              </form>
            </Card>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ProfilePage;
